import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const WhatsAppContext = createContext();

export const useWhatsApp = () => {
  const context = useContext(WhatsAppContext);
  if (!context) {
    throw new Error('useWhatsApp must be used within a WhatsAppProvider');
  }
  return context;
};

export const WhatsAppProvider = ({ children }) => {
  const [whatsappConnected, setWhatsappConnected] = useState(false);
  const [whatsappStatus, setWhatsappStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkWhatsAppStatus = useCallback(async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || '/api';
      const response = await fetch(`${API_URL}/whatsapp/status`, {
        method: 'GET',
        signal: AbortSignal.timeout(5000)
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('[WhatsAppContext] API Response:', data);
        setWhatsappStatus(data);
        
        // CHECK: Sistema está operacional se status for CONNECTED ou QR.
        // API retorna status em MAIÚSCULO ('CONNECTED', 'DISCONNECTED', 'CONNECTING').
        // Normalizar com toUpperCase() para comparação robusta.
        const statusUp = (data.status || '').toUpperCase();
        const isOperational = statusUp === 'CONNECTED' || statusUp === 'OPEN' || statusUp === 'QR' || data.connected === true;
        console.log('[WhatsAppContext] isOperational calculated:', isOperational, 'status:', data.status);
        setWhatsappConnected(isOperational);
      } else {
        console.log('[WhatsAppContext] Response not OK');
        setWhatsappConnected(false);
        setWhatsappStatus(null);
      }
    } catch (error) {
      console.log('[WhatsAppContext] Error:', error);
      setWhatsappConnected(false);
      setWhatsappStatus(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkWhatsAppStatus();
    const interval = setInterval(checkWhatsAppStatus, 15000); // Check every 15 seconds (evitar race condition)
    return () => clearInterval(interval);
  }, [checkWhatsAppStatus]);

  return (
    <WhatsAppContext.Provider value={{ whatsappConnected, whatsappStatus, loading, checkWhatsAppStatus }}>
      {children}
    </WhatsAppContext.Provider>
  );
};
